module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"scrollDown":"Scroll Down","shopByCategory":"Shop By Category","sale":"Sale","saleDesc":"Don\u0027t miss our monthly deals on selective products","latest":"Latest Products","bestSellers":"Best Sellers"},"ar":{"scrollDown":"","shopByCategory":"تسوق بالقسم","sale":"تخفيضات","saleDesc":"لا يفوتك عروضنا الشهرية","latest":"آخر المنتجات","bestSellers":"الأكثر مبيعا"}}')
  delete Component.options._Ctor
}
